import { ApisauceInstance } from 'apisauce';

const updateUser = (
  userId: string,
  user: {
    phoneNumber?: string;
    displayName?: string;
  },
  api: ApisauceInstance,
) => api.patch(`/v1/users/${userId}`, user);

export default updateUser;
